import { VueExtension } from '../../utils/extensions/vue';
import Button from './button.jsx';
import './button.scss';

VueExtension.WithInstall(Button);

export default Button;
